(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vk-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.getElementById('vk-pdp');
    if (!root) return;

    var select = root.querySelector('input[name="id"]');
    var priceWrap = root.querySelector('#vk-pdp-price');
    var priceCurrent = root.querySelector('[data-vk-price-current]');
    var priceCompare = root.querySelector('[data-vk-price-compare]');
    var btns = root.querySelectorAll('[data-vk-variant-btn]');

    // Variant button handlers ONLY (cart logic handled by vk-pdp-atc-state-fix.js)
    if (btns && btns.length > 0) {
      function setCompare(text) {
        if (!priceWrap) return;
        if (!text) {
          if (priceCompare && priceCompare.parentNode) priceCompare.parentNode.removeChild(priceCompare);
          priceCompare = null;
          return;
        }
        if (!priceCompare) {
          priceCompare = document.createElement('span');
          priceCompare.className = 'vk-pdp__price-compare';
          priceCompare.setAttribute('data-vk-price-compare', '');
          priceWrap.appendChild(priceCompare);
        }
        priceCompare.textContent = text;
      }

      function setActive(activeBtn) {
        btns.forEach(function (b) {
          var isActive = b === activeBtn;
          b.classList.toggle('is-active', isActive);
          b.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      }

      btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = btn.getAttribute('data-variant-id');
          if (!id) return;
          if (select) {
            select.value = id;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
          if (priceCurrent) priceCurrent.textContent = btn.getAttribute('data-variant-price') || priceCurrent.textContent;
          setCompare(btn.getAttribute('data-variant-compare') || '');
          setActive(btn);
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
